let closeHomeMess = document.querySelector('.close-hm');
if(closeHomeMess){
  closeHomeMess.addEventListener('click', function(event){
    event.preventDefault();
    document.querySelector('.home-message').classList.add('remove');
    document.querySelector('body').classList.remove('home-message-on');
    document.querySelector('footer').classList.remove('hm-on');
  });

  document.querySelector('footer').classList.add('hm-on');
}

// setTimeout(function() {
//   document.querySelector('#newsletter').classList.add('appear');
// }, 10000);

document.addEventListener("DOMContentLoaded", function () {
  // Select the video element
  const videoElement = document.querySelector(".home-block.video video");

  if (videoElement) {
    // Create an Intersection Observer
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            // Play the video when it's in view
            videoElement.play();
          } else {
            // Pause the video when it's out of view
            //videoElement.pause();
          }
        });
      },
      {
        threshold: 0.5, // Trigger when 50% of the video is visible
      }
    );

    // Observe the video element
    observer.observe(videoElement);
  }
});
